import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const recharge = async (params: object) => {
  return await POST({
    url: Api.recharge,
    params: {
      ...params
    },
    showError: false
  })
}
